import React from 'react';
import originalStyles from '../../styles/SitemapBottom.module.scss';
import { extractStyle } from '../../styles/styles-extract-util';
import { STATIC_SITE_MAP, EXTERNAL_URL } from '../../consts/asial-websites-sitemap.const';
import GlobalIconRef from '../../resources/Language-icon.svg';

export const SitemapBottom: React.FC = () => {
  const styles = extractStyle(originalStyles);
  const getURLFromSitemapData = ({ host, path }: { host: string; path: string }) => host + path;

  return (
    <div className={styles.sitemapBottom}>
      <div className={styles.contactGlobalRow}>
        <a href={getURLFromSitemapData(STATIC_SITE_MAP.CONTACT)}>
          <button className={styles.contactButton}>お問い合わせ</button>
        </a>
        <a className={styles.globalLink} href={EXTERNAL_URL.ASIAL_EN} target="_blank" rel="noreferrer">
          <img src={GlobalIconRef} />
          <span>Global</span>
        </a>
      </div>
      <div className={styles.policyLinks}>
        <div className={styles.policyRow}>
          <a href={getURLFromSitemapData(STATIC_SITE_MAP.SITE_POLICY)}>{STATIC_SITE_MAP.SITE_POLICY.title}</a>
          <a href={getURLFromSitemapData(STATIC_SITE_MAP.PRIVACY_POLICY)}>{STATIC_SITE_MAP.PRIVACY_POLICY.title}</a>
        </div>
        <div className={styles.policyRow}>
          <a href={getURLFromSitemapData(STATIC_SITE_MAP.INFORMATION_SECURITY_POLICY)}>{STATIC_SITE_MAP.INFORMATION_SECURITY_POLICY.title}</a>
          <a href={getURLFromSitemapData(STATIC_SITE_MAP.QUALITY_POLICY)}>{STATIC_SITE_MAP.QUALITY_POLICY.title}</a>
        </div>
      </div>
    </div>
  );
};